import { menu } from './modules/menu.js';
import { homeHeroSlick } from './modules/slick.js';
import { productSlick } from './modules/slick.js';
import { postSlider } from './modules/slick.js';
import { logoSlider } from './modules/slick.js';
import { recipesSlider } from './modules/slick.js';
import { productInfoSlick } from './modules/slick.js';
import { restaurantSlider } from './modules/slick.js';
import { select2Extansion } from './modules/select2.js';
import { select2 } from './modules/select2.js';
import { accordion } from './modules/accordion.js';
import { archiveOpen } from './modules/archive.js';
import { searchModal } from './modules/searchModal.js';
import { formAnimation } from './modules/formAnimation';
import { styleMapDirections } from './modules/styling';
import { addPlaceholder } from './modules/styling';
import { whereToBuyList } from './modules/whereToBuyList';
import { searchFormHandler } from "./modules/form-handler";
import { popup } from "./modules/popup";
import { popupGallery } from "./modules/popupGallery";
import { productChangeCurrentItem } from './modules/slick.js';
import { collectFormData } from './modules/collectFormData'
import { datePicker } from './modules/datePicker'

$(document).ready(function () {
    menu();
    homeHeroSlick();
    productSlick();
    postSlider();
    logoSlider();
    recipesSlider();
    productInfoSlick();
    select2Extansion();
    select2();
    accordion();
    archiveOpen();
    searchModal();
    formAnimation();
    searchFormHandler();
    styleMapDirections();
    whereToBuyList();
    popup();
    popupGallery();
    addPlaceholder();
    productChangeCurrentItem();
    collectFormData();
    datePicker();
    restaurantSlider();

});

String.prototype.stripTags = function(){
   return this.replace(/(<([^>]+)>)/ig,"");
}
